import * as Sentry from '@sentry/node';
import React, { ReactNode } from 'react';

class ErrorBoundary extends React.Component<
  { children: ReactNode },
  { error?: Error; eventId?: string }
> {
  constructor(props: { children: ReactNode }) {
    super(props);
    this.state = {};
  }

  static getDerivedStateFromError(error: Error) {
    return { error };
  }

  componentDidCatch(error: Error, errorInfo: React.ErrorInfo) {
    Sentry.withScope((scope) => {
      scope.setExtras(errorInfo as unknown as Record<string, unknown>);
      Sentry.captureException(error);
    });
  }

  render() {
    const { children } = this.props;
    const { error } = this.state;

    if (error) {
      throw error;
    }

    return children;
  }
}

export default ErrorBoundary;
